import React, { ReactNode } from 'react';
import { ReactComponent as CheckSVG } from './images/orangeCheck.svg';
import { CtaButton, CtaButtonProps } from 'components/global/CtaButton';

import {
  Disclaimer,
  CustomFormulaContainer,
  InnerBox,
  LeftContent,
  TopSection,
  Subtitle,
  Title,
  TagHeadline,
  Tag,
  Tags,
  Price,
  ctaStyles,
  ValuePropContainer,
  SVGContainer,
  ValueProp,
  DesktopBackgroundContainer,
} from './CustomFormula.style';
import { Theme } from '../types';

export interface CustomFormulaProps {
  title: ReactNode;
  subtitle?: string;
  tagHeadline?: string;
  disclaimer?: string;
  price?: ReactNode;
  tags?: string[];
  ctaButton?: CtaButtonProps;
  theme?: Theme;
  valueProp?: ReactNode;
  mobileImage: ReactNode;
  desktopImage: ReactNode;
}

const moduleName = 'customFormula';

export const CustomFormulaPop = ({
  title,
  subtitle,
  tagHeadline,
  disclaimer,
  price,
  tags = [],
  ctaButton,
  theme = 'primary',
  valueProp,
  mobileImage,
  desktopImage,
}: CustomFormulaProps) => (
  <CustomFormulaContainer data-module={moduleName} themeType={theme}>
    <DesktopBackgroundContainer>{desktopImage}</DesktopBackgroundContainer>
    <InnerBox themeType={theme}>
      {mobileImage}
      <LeftContent>
        <TopSection>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          {tagHeadline && <TagHeadline>{tagHeadline}</TagHeadline>}
          <Tags>
            {tags.map((prop, index) => (
              <Tag key={index}>{prop}</Tag>
            ))}
          </Tags>
          {price && <Price>{price}</Price>}
        </TopSection>
        {ctaButton && <CtaButton css={ctaStyles} {...ctaButton} />}
        {disclaimer && (
          <Disclaimer
            dangerouslySetInnerHTML={{
              __html: disclaimer,
            }}
          />
        )}
      </LeftContent>
      {valueProp && (
        <ValuePropContainer>
          <SVGContainer>
            <CheckSVG />
          </SVGContainer>
          <ValueProp>{valueProp}</ValueProp>
        </ValuePropContainer>
      )}
    </InnerBox>
  </CustomFormulaContainer>
);
